/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Kódy slev ${i.storeName}`
};

const da_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Rabatkoder til ${i.storeName}`
};

const de_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Rabattcodes für ${i.storeName}`
};

const en_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Discount codes ${i.storeName}`
};

const es_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Códigos promocionales ${i.storeName}`
};

const fr_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Codes promo ${i.storeName}`
};

const hu_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.storeName} promóciós kódjai`
};

const it_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Codici sconto ${i.storeName}`
};

const nl_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Kortingscodes ${i.storeName}`
};

const pl_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Kody rabatowe ${i.storeName}`
};

const pt_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Códigos promocionais ${i.storeName}`
};

const sv_discount_codes_title = /** @type {(inputs: { storeName: NonNullable<unknown> }) => string} */ (i) => {
	return `Rabattkoder ${i.storeName}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ storeName: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_title", locale)
	if (locale === "cs") return cs_discount_codes_title(inputs)
	if (locale === "da") return da_discount_codes_title(inputs)
	if (locale === "de") return de_discount_codes_title(inputs)
	if (locale === "en") return en_discount_codes_title(inputs)
	if (locale === "es") return es_discount_codes_title(inputs)
	if (locale === "fr") return fr_discount_codes_title(inputs)
	if (locale === "hu") return hu_discount_codes_title(inputs)
	if (locale === "it") return it_discount_codes_title(inputs)
	if (locale === "nl") return nl_discount_codes_title(inputs)
	if (locale === "pl") return pl_discount_codes_title(inputs)
	if (locale === "pt") return pt_discount_codes_title(inputs)
	return sv_discount_codes_title(inputs)
};
export { discount_codes_title as "discount_codes.title" }